import type { TrainingLoopComponent } from '../sim/entity';

/** Milliseconds per authored tick in a {@link TrainingLoopComponent}. */
const TICK_MS = 50;

/**
 * One reconcile pass's scheduling decision for a `trainingLoop` entity
 * (PRD #837 slice 3): given the entity's booked replay time (undefined on
 * first sight), decide whether the clip replays this pass and when the next
 * replay is due. First sight books `phaseTicks` ahead so a line of trainers
 * drills staggered; a due replay books `periodTicks` ahead. Pure so the
 * cadence survives renderer reconcile refactors; the renderer owns the
 * per-entity map and deletes the entry when the entity leaves the snapshot.
 */
export function trainingLoopSchedule(
  bookedAt: number | undefined,
  loop: Pick<TrainingLoopComponent, 'periodTicks' | 'phaseTicks'>,
  now: number,
): { play: boolean; nextAt: number } {
  const dueAt = bookedAt ?? now + loop.phaseTicks * TICK_MS;
  if (now >= dueAt) {
    return { play: true, nextAt: now + loop.periodTicks * TICK_MS };
  }
  return { play: false, nextAt: dueAt };
}
